module.exports = __webpack_public_path__ + "static/media/global_nia_online_mind_body_fitness.d5a5f7e9.webp";